import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import Auth from "@aws-amplify/auth";
import { awsAuthConfig } from "./cognito/config";


Auth.configure(awsAuthConfig);
// BootstrapVueのインポート
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import { BootstrapVue3 } from 'bootstrap-vue-3'

createApp(App)
  .use(router)
  .use(store) // Vuexストアの使用
  .use(BootstrapVue3)
  .mount('#app')
